import { Add, ArrowDownward, ArrowUpward, Gavel } from '@mui/icons-material';
import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import {
  IAdminstrativeUnit,
  ICourtAdminstrativeUnitAssignment,
  ICourtCourtRole,
  IFederalState,
} from '../../../Interfaces/IAemter';
import { ILegalPhaseFullObject } from '../../../Interfaces/ILegalPhase';
import {
  ILegalRequirement,
  ILegalRequirementFullObject,
} from '../../../Interfaces/ILegalRequirement';
import { ILegalRequirementTemplateFullObject } from '../../../Interfaces/ILegalRequirementTemplate';
import { LegalPhaseCopyRequirement } from '../../../LegalTransactionType/LegalPhaseCopyRequirement';
import { ConfirmDelete } from '../../../core/ConfirmDelete';
import { PopupAlert } from '../../../core/PopupAlert';
import { getFetch } from '../../../hooks/useFetch';
import { LegalPhaseAddAdminUnit } from '../LegalPhaseAddAdminUnit';
import { LegalPhaseDialogEdit } from './LegalPhaseDialogEdit';
import { ILegalRequirementDeadline } from '../../../Interfaces/ILegalRequirement_deadlines';
import { EditLegalRequirement } from './EditLegalRequirement';
import { LegalRequirementRowEdit } from './LegalRequirementRowEdit';

interface IProps {
  currentPhase: ILegalPhaseFullObject;
  legalPhaseArray: ILegalPhaseFullObject[];
  setLegalPhaseArray: Function;
  adminUnitArray: IAdminstrativeUnit[];
  federalStateArray: IFederalState[];
  courtcourtroleArray: ICourtCourtRole[];
  legaltransactionId: number;
  selectedRequirementsIds: number[];
  setSelectedRequirementsIds: Function;
}

export const LegalPhaseRowEdit: React.FC<IProps> = ({
  currentPhase,
  legalPhaseArray,
  setLegalPhaseArray,
  adminUnitArray,
  federalStateArray,
  courtcourtroleArray,
  legaltransactionId,
  selectedRequirementsIds,
  setSelectedRequirementsIds,
}) => {
  const [currentPhaseEdit, setCurrentPhaseEdit] =
    useState<ILegalPhaseFullObject>(currentPhase);
  const [isOpenAddLegalRequirement, setIsOpenAddLegalRequirement] =
    useState(false);
  const [openAdminUnitDialog, setOpenAdminUnitDialog] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [
    courtAdminstrativeUnitAssignmentArray,
    setCourtAdminstrativeUnitAssignmentArray,
  ] = useState<ICourtAdminstrativeUnitAssignment[]>([]);

  const handleAddNewLegalRequirement = () => {
    setIsOpenAddLegalRequirement(true);
  };

  const handleTemplateToRequirement = (
    localLegalReqArray: ILegalRequirementTemplateFullObject[]
  ) => {
    const tmpArray: ILegalRequirementFullObject[] = [];
    const maxPosition =
      Math.max(...currentPhase.LegalRequirementArray.map(x => x.Position)) + 1;

    localLegalReqArray.map((x, i) => {
      let idCounter = 1;
      const newRequirement = {
        ...x,
        idLegalPhase: currentPhase.idLegalPhase,
        idLegalRequirement: x.idLegalRequirementTemplate,
        LegalRequirement: x.LegalRequirementTemplate,
        enableError: x.hasError,
        enableFreeTextError: x.hasErrorFreeText,
        isComplete: false,
        User_idUser: null,
        Position: maxPosition + i,
        ManualProcessingTime: false,
        idLegalRequirementTemplate: x.currentProcessingTime,
        initialProcessingTime: x.initialProcessingTime,
        UserDeadlineNotified: false,
        sendInternLegalRequirementMail: false,
        isEmailSent: false,
        sendEmailAgain: false,
        DocumentArrayEmployees: x.DocumentArray,
      } as ILegalRequirementFullObject;

      // Ändere die IDs in DocumentArray
      if (newRequirement.DocumentArrayEmployees) {
        newRequirement.DocumentArrayEmployees =
          newRequirement.DocumentArrayEmployees.map((doc, index) => ({
            ...doc,
            idDocument: -idCounter++, // ID zuweisen, beginnend bei -1
          }));
      }

      const newDeadlineArray =
        x.DeadlineArray?.map(y => {
          if (y.idLegalRequirementTemplate) {
            return (
              legalPhaseArray
                .filter(
                  legalPhase => legalPhase.Position <= currentPhase.Position
                )
                .map(legalPhase =>
                  legalPhase.LegalRequirementArray.filter(
                    z =>
                      z.idLegalRequirementTemplate ===
                      y.idLegalRequirementTemplate
                  ).map(z => {
                    return {
                      idLegalRequirement: z.idLegalRequirement,
                      idLegalRequirementState: y.idLegalRequirementState,
                      idLegalTransaction: legaltransactionId,
                    } as ILegalRequirementDeadline;
                  })
                )
                .flat() || null
            ).flat();
          } else if (y.idLegalTransactionState) {
            return {
              idLegalRequirementState: y.idLegalRequirementState,
              idLegalTransaction: legaltransactionId,
            } as ILegalRequirementDeadline;
          } else {
            return null;
          }
        }) || [];
      //remove null values from array

      newRequirement.DeadlineArray = newDeadlineArray
        .flat()
        .filter(x => x) as ILegalRequirementDeadline[];
      tmpArray.push(newRequirement);
    });

    updateLegalRequirementArray([
      ...currentPhase.LegalRequirementArray,
      ...tmpArray,
    ]);
  };

  const updateLegalRequirementArray = (
    localLegalReqArray: ILegalRequirement[]
  ) => {
    const tmpObject = { ...currentPhase };
    tmpObject.LegalRequirementArray = localLegalReqArray;
    setLegalPhaseArray([
      ...legalPhaseArray.map(x =>
        x.idLegalPhase === tmpObject.idLegalPhase ? tmpObject : x
      ),
    ]);
  };

  const isFirstDisabled = () => {
    const currentIndex: number = legalPhaseArray
      .map(x => x.idLegalPhase)
      .indexOf(currentPhase.idLegalPhase);
    return currentIndex === 0;
  };

  const isLastDisabled = () => {
    const currentIndex: number = legalPhaseArray
      .map(x => x.idLegalPhase)
      .indexOf(currentPhase.idLegalPhase);
    return currentIndex === legalPhaseArray.length - 1;
  };

  const getUp = () => {
    const targetObject = legalPhaseArray.find(
      x => x.Position === currentPhaseEdit.Position - 1
    );

    if (targetObject === undefined) {
    } else {
      targetObject.Position = targetObject.Position + 1;
      currentPhaseEdit.Position = currentPhaseEdit.Position - 1;

      setLegalPhaseArray([
        ...legalPhaseArray.map(x =>
          x.idLegalPhase === targetObject?.idLegalPhase
            ? targetObject
            : x.idLegalPhase === currentPhaseEdit.idLegalPhase
              ? currentPhaseEdit
              : x
        ),
      ]);
    }
  };

  const getDown = () => {
    const targetObject = legalPhaseArray.find(
      x => x.Position === currentPhaseEdit.Position + 1
    );

    if (targetObject === undefined) {
    } else {
      targetObject.Position = targetObject.Position - 1;
      currentPhaseEdit.Position = currentPhaseEdit.Position + 1;

      setLegalPhaseArray([
        ...legalPhaseArray.map(x =>
          x.idLegalPhase === targetObject?.idLegalPhase
            ? targetObject
            : x.idLegalPhase === currentPhaseEdit.idLegalPhase
              ? currentPhaseEdit
              : x
        ),
      ]);
    }
  };

  const handleAdminUnitChange = useCallback(
    (newAdminUnit: IAdminstrativeUnit | null) => {
      if (newAdminUnit === null) {
        const tmpObject = currentPhase;
        tmpObject.idAdministrativeUnit = null;
        setCurrentPhaseEdit(tmpObject);
      } else {
        if (courtAdminstrativeUnitAssignmentArray.length > 0) {
          handleAdminUnitAssignmentAfterChange(
            courtAdminstrativeUnitAssignmentArray,
            newAdminUnit
          );
        } else {
          getFetch(
            '/courtadminstrativeunitassignment/getbyadminunit/',
            newAdminUnit.idAdministrativeUnit,
            (adminUnitAssignment: ICourtAdminstrativeUnitAssignment[]) => {
              setCourtAdminstrativeUnitAssignmentArray(adminUnitAssignment);
              handleAdminUnitAssignmentAfterChange(
                adminUnitAssignment,
                newAdminUnit
              );
            },
            (sucess: boolean) => setShowAlert(!sucess)
          );
        }
      }
    },
    [
      currentPhase,
      legalPhaseArray,
      setLegalPhaseArray,
      adminUnitArray,
      federalStateArray,
      courtcourtroleArray,
      legaltransactionId,
    ]
  );

  const handleAdminUnitAssignmentAfterChange = useCallback(
    (
      adminUnitAssignment: ICourtAdminstrativeUnitAssignment[],
      newAdminUnit: IAdminstrativeUnit
    ) => {
      const tmpObject = currentPhase;
      tmpObject.idAdministrativeUnit = newAdminUnit.idAdministrativeUnit;
      tmpObject.AdministrativeUnit = newAdminUnit.AdministrativeUnit;
      tmpObject.LegalRequirementArray.forEach(x => {
        const tmpCourt = adminUnitAssignment.find(
          y => y.idCourtRole === x.idCourtRole
        );
        if (tmpCourt !== undefined) {
          x.idCourt = tmpCourt.idCourt;
          x.Court = tmpCourt.Court;
        }
      });
      setCurrentPhaseEdit(tmpObject);
    },
    [
      currentPhase,
      legalPhaseArray,
      setLegalPhaseArray,
      adminUnitArray,
      federalStateArray,
      courtcourtroleArray,
      legaltransactionId,
    ]
  );

  const handleDelete = () => {
    setLegalPhaseArray([
      ...legalPhaseArray.filter(
        x => x.idLegalPhase !== currentPhase.idLegalPhase
      ),
    ]);
  };

  useEffect(() => {
    setLegalPhaseArray([
      ...legalPhaseArray.map(x =>
        x.idLegalPhase === currentPhaseEdit.idLegalPhase ? currentPhaseEdit : x
      ),
    ]);
  }, [currentPhaseEdit]);

  return (
    <>
      <EditLegalRequirement
        isOpenEditLegalRequirement={isOpenAddLegalRequirement}
        setIsOpenEditLegalRequirement={setIsOpenAddLegalRequirement}
        updateLegalRequirementArray={updateLegalRequirementArray}
        currentPhase={currentPhase}
        courtcourtroleArray={courtcourtroleArray}
        legaltransactionId={legaltransactionId}
      ></EditLegalRequirement>

      <PopupAlert
        text='Fehler beim hinterlegen der Gemarkung. Bitte versuchen Sie es erneut.'
        show={showAlert}
        setShow={setShowAlert}
        severity='error'
      />

      <TableRow>
        <TableCell colSpan={2}>{currentPhase.LegalPhase}</TableCell>
        <TableCell>
          {currentPhase.PreconditionArray.map(x => x.LegalPhase).join(', ')}
        </TableCell>
        <TableCell>
          <Typography variant='caption'>
            {currentPhase.AdministrativeUnit}
          </Typography>
        </TableCell>
        <TableCell>
          <Tooltip
            title={
              !!legalPhaseArray
                .find(x => x.Position === currentPhase.Position + 1)
                ?.PreconditionArray.find(
                  x => x.idLegalPhase === currentPhase.idLegalPhase
                )
                ? 'Die Phase wird von der darunterliegenden Phase als Vorgänger verwendet!'
                : 'Phase nach unten verschieben'
            }
            disableInteractive
            disableHoverListener={false}
          >
            <span style={{ display: 'inline-block', float: 'right' }}>
              <IconButton
                size='small'
                disabled={
                  isLastDisabled() ||
                  !!legalPhaseArray
                    .find(x => x.Position === currentPhase.Position + 1)
                    ?.PreconditionArray.find(
                      x => x.idLegalPhase === currentPhase.idLegalPhase
                    )
                }
                onClick={getDown}
              >
                <ArrowDownward />
              </IconButton>
            </span>
          </Tooltip>

          <Tooltip
            title={
              !!currentPhase.PreconditionArray.find(
                x =>
                  x.idLegalPhase ===
                  legalPhaseArray.find(
                    x => x.Position === currentPhase.Position - 1
                  )?.idLegalPhase
              )
                ? 'Die Phase benutzt die darüberliegende Phase als Vorgänger!'
                : 'Phase nach oben verschieben'
            }
            disableInteractive
            disableHoverListener={false}
          >
            <span style={{ display: 'inline-block', float: 'right' }}>
              <IconButton
                size='small'
                disabled={
                  isFirstDisabled() ||
                  !!currentPhase.PreconditionArray.find(
                    x =>
                      x.idLegalPhase ===
                      legalPhaseArray.find(
                        x => x.Position === currentPhase.Position - 1
                      )?.idLegalPhase
                  )
                }
                onClick={getUp}
              >
                <ArrowUpward />
              </IconButton>
            </span>
          </Tooltip>

          <IconButton
            sx={{ float: 'right' }}
            size='small'
            onClick={handleAddNewLegalRequirement}
          >
            <Add />
          </IconButton>

          <LegalPhaseCopyRequirement
            idLegalPhaseTemplate={currentPhase.idLegalPhase}
            startId={Math.min(
              ...currentPhase.LegalRequirementArray.map(
                x => x.idLegalRequirement
              )
            )}
            setArray={handleTemplateToRequirement}
          />
        </TableCell>
        <TableCell colSpan={4} />
        <TableCell>
          <LegalPhaseDialogEdit
            currentPhase={currentPhase}
            currentPhaseEdit={currentPhaseEdit}
            setCurrentPhaseEdit={setCurrentPhaseEdit}
            legalPhaseArray={legalPhaseArray}
            setLegalPhaseArray={setLegalPhaseArray}
          />
          <Tooltip title='Gemarkung zur Phase hinzufügen. Dies weißt alle Ämter, welche in den Maßnahmen der Phase definiert sind, automatisch den zuständigen Ämtern der Phase zu.'>
            <IconButton
              size='small'
              onClick={() => setOpenAdminUnitDialog(true)}
            >
              <Gavel />
            </IconButton>
          </Tooltip>
          <ConfirmDelete
            itemText='die aktulle Phase und deren Bedingungen '
            functionToDelete={handleDelete}
          />
        </TableCell>
      </TableRow>

      {currentPhase.LegalRequirementArray.sort((a, b) =>
        a.Position < b.Position ? -1 : 1
      ).map(x => (
        <LegalRequirementRowEdit
          key={`idLegalRequirement-${x.idLegalRequirement}`}
          currentRequirement={x}
          currentPhase={currentPhase}
          setLegalRequirementArray={updateLegalRequirementArray}
          courtcourtroleArray={courtcourtroleArray}
          legaltransactionId={legaltransactionId}
          selectedRequirementsIds={selectedRequirementsIds}
          setSelectedRequirementsIds={setSelectedRequirementsIds}
        />
      ))}

      <LegalPhaseAddAdminUnit
        open={openAdminUnitDialog}
        currentAdminUnit={adminUnitArray.find(
          x => x.idAdministrativeUnit === currentPhase.idAdministrativeUnit
        )}
        adminUnitArray={adminUnitArray}
        federalStateArray={federalStateArray}
        onClose={() => setOpenAdminUnitDialog(false)}
        onSave={handleAdminUnitChange}
      />
    </>
  );
};
